import { ChevronDown, ChevronUp } from '@carbon/icons-react'
import React, { useState } from 'react'

import { DDSTypography } from 'den-design-system'
import pallete from '../../../../../../../../global/newPallete'

interface UsageData {
  type: string
  allowed: string
  used: number
}

interface UsageTableProps {
  timeframe: string
  data: UsageData[]
}

const UsageHistory: React.FC<UsageTableProps> = ({ timeframe, data }) => {
  const [open, setOpen] = useState(false)

  return (
    <div className='border rounded-[4px] shadow-sm w-full'>
      {/* Header */}
      <div
        className='flex justify-between items-center p-[12px] cursor-pointer select-none'
        onClick={() => setOpen(!open)}
      >
        <DDSTypography.Title
          type='h5'
          variant='semiBold'
          color={pallete.colors.textDark5}
          className='flex items-center'
        >
          {timeframe}
        </DDSTypography.Title>
        {open ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {/* Table */}
      {open && (
        <div className='overflow-x-auto'>
          <table className='w-full border-t'>
            <thead className='bg-white'>
              <tr>
                <th className='text-left p-[12px]'>
                  <DDSTypography.Title
                    type='h5'
                    variant='medium'
                    color={pallete.colors.textDark5}
                  >
                    Type
                  </DDSTypography.Title>
                </th>

                <th className='text-left p-[12px]'>
                  <DDSTypography.Title
                    type='h5'
                    variant='medium'
                    color={pallete.colors.textDark5}
                  >
                    Used in the month
                  </DDSTypography.Title>
                </th>
                <th className='text-left p-[12px]'>
                  <DDSTypography.Title
                    type='h5'
                    variant='medium'
                    color={pallete.colors.textDark5}
                  >
                    Allowed for the month
                  </DDSTypography.Title>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr
                  key={index}
                  className='border-t hover:bg-gray-50 transition'
                >
                  <td className='p-[12px] w-[600px]'>
                    <DDSTypography.Paragraph
                      size='para'
                      color={pallete.colors.textDark5}
                      variant='regular'
                    >
                      {row.type}
                    </DDSTypography.Paragraph>
                  </td>

                  <td className='p-[12px]'>
                    <DDSTypography.Paragraph
                      size='para'
                      color={pallete.colors.textDark5}
                      variant='regular'
                    >
                      {row.used}
                    </DDSTypography.Paragraph>
                  </td>
                  <td className='p-[12px]'>
                    <DDSTypography.Paragraph
                      size='para'
                      color={pallete.colors.textDark5}
                      variant='regular'
                    >
                      {row.allowed}
                    </DDSTypography.Paragraph>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default UsageHistory
